import WorkDataList from "../Component";
import { useHistory } from "react-router-dom";
import React, { useState, useRef, useEffect } from "react";
import { Button, InputItem, List, Modal, Toast, WhiteSpace } from "antd-mobile";
import instance from "../../../../util/axios";
import { Result } from "../../../../schema";
import DictionarySelect from "../../../../component/CheckBoxItem";
import "../main.css";
import moment from "moment";

export default function CompletionList() {
  const [step, setStep] = useState<1 | 2>(1);
  const CompletionListRef = useRef<any>();
  const history = useHistory();
  const [selectedRows, setSelectedRows] = useState<any[]>([]);

  const [dialogForm, setDialogForm] = useState<{
    visible: boolean;
  }>({
    visible: false,
  });
  const [homeParams, setHomeParams] = useState<{
    isReturning: string;
    isOther?: string;
    workshopId?: string;
    procedureId?: string;
    remarkId?: string;
    staffId?: string;
    orderCalType?: string;
    useGroup?: string;
    groupId?: string;
    joinedStaffsId?: string;
    fillingId?: string;
    workDate?: string;
    submitId?: string;
  }>({
    isReturning: "2",
  });
  const [submitForm, setSubmitForm] = useState<{
    visible: boolean;
    skuId?: string;
    userId?: string;
    staffId?: string;
    skuName?: string;
    formulaName?: string;
    departmentIds?: string;
    procedureIds?: string;
    procedureId?: string;
    psiId?: string;
    psiName?: string;
    specs?: string;
    workshopId?: string;
    remarkId?: string;
    workflowId?: string;
    orderDetailId?: string;
    orderTime?: string;
    isMultiple?: string;
    orderNo?: string;
    quantity?: string;
    pieces?: string;
    joinedStaffsId?: string;
    orderCalType?: string;
    selectedCount?: string;
    isReturning?: string;
    isOther?: string;
    status?: string;
    fillingId?: string;
    submitId?: string;
  }>({
    visible: false,
  });

  useEffect(() => {
    let url = window.location.href; // 获取请求进来的完整url
    if (url.indexOf("?") === -1) return;
    let tstr = url.substring(url.indexOf("?") + 1).split("&"); // 先截取url的?后面的参数部分，在根据&分割成参数数组
    setHomeParams({
      isReturning:
        tstr[4].split("=")[1] === undefined ||
        tstr[4].split("=")[1] === "undefined"
          ? ""
          : tstr[4].split("=")[1],
      isOther:
        tstr[5].split("=")[1] === undefined ||
        tstr[5].split("=")[1] === "undefined"
          ? ""
          : tstr[5].split("=")[1],
      workshopId:
        tstr[6].split("=")[1] === undefined ||
        tstr[6].split("=")[1] === "undefined"
          ? ""
          : tstr[6].split("=")[1],
      procedureId: tstr[0].split("=")[1],
      remarkId:
        tstr[7].split("=")[1] === undefined ||
        tstr[7].split("=")[1] === "undefined"
          ? ""
          : tstr[7].split("=")[1],
      staffId: tstr[1].split("=")[1],
      orderCalType: tstr[2].split("=")[1],
      useGroup: tstr[9].split("=")[1],
      groupId: tstr[10].split("=")[1],
      joinedStaffsId:
        tstr[3].split("=")[1] === undefined ||
        tstr[3].split("=")[1] === "undefined"
          ? ""
          : tstr[3].split("=")[1],
      workDate: tstr[11].split("=")[1],
    });
    // if() {

    // }
    setSubmitForm((prev) => ({
      ...prev,
      procedureId: tstr[0].split("=")[1],
      staffId: tstr[1].split("=")[1],
      orderCalType: tstr[2].split("=")[1],
      joinedStaffsId:
        tstr[3].split("=")[1] === undefined ||
        tstr[3].split("=")[1] === "undefined"
          ? ""
          : tstr[3].split("=")[1],
      isReturning:
        tstr[4].split("=")[1] === undefined ||
        tstr[4].split("=")[1] === "undefined"
          ? ""
          : tstr[4].split("=")[1],
      isOther:
        tstr[5].split("=")[1] === undefined ||
        tstr[5].split("=")[1] === "undefined"
          ? ""
          : tstr[5].split("=")[1],
      remarkId:
        tstr[7].split("=")[1] === undefined ||
        tstr[7].split("=")[1] === "undefined"
          ? ""
          : tstr[7].split("=")[1],
    }));
  }, []);

  const descriptionCutting = [
    {
      fieldName: "completeTime",
      fieldShowName: "计划完成时间",
      width: 120,
    },
    {
      fieldName: "orderNo",
      fieldShowName: "批号",
      width: 120,
    },
    {
      fieldName: "skuName",
      fieldShowName: "产品",
      width: 120,
    },
    {
      fieldName: "allotQuantity",
      fieldShowName: "商品分配数量",
      width: 120,
    },
    {
      fieldName: "code",
      fieldShowName: "物料编码",
      width: 120,
    },
    {
      fieldName: "psiName",
      fieldShowName: "物料名称",
      inputType: 0,
      width: 120,
    },
    {
      fieldName: "length",
      fieldShowName: "长度",
      width: 120,
    },
    // {
    //   fieldName: "bomQuantity",
    //   fieldShowName: "匹配基数",
    //   width: 120,
    // },
    {
      fieldName: "bomTotalQuantity",
      fieldShowName: "所需下料数量",
      width: 120,
    },
    {
      fieldName: "practicalLength",
      fieldShowName: "实际下料长度",
      width: 120,
    },
    {
      fieldName: "practicalQuantity",
      fieldShowName: "实际下料数量",
      width: 120,
    },
    {
      fieldName: "outQuantity",
      fieldShowName: "已下料数量",
      width: 120,
    },
    {
      fieldName: "noOutQuantity",
      fieldShowName: "未下料数量",
      width: 120,
    },
  ];

  const descriptionNoCutting = [
    {
      fieldName: "orderTime",
      fieldShowName: "计划完成时间",
      width: 120,
    },
    {
      fieldName: "orderNo",
      fieldShowName: "批号",
      width: 120,
    },
    {
      fieldName: "dealerName",
      fieldShowName: "客户名称",
      width: 120,
    },
    {
      fieldName: "skuName",
      fieldShowName: "产品",
      width: 120,
    },
    {
      fieldName: "gear",
      fieldShowName: "排档方式",
      width: 120,
    },
    {
      fieldName: "gearModel",
      fieldShowName: "主管/档管规格",
      width: 120,
    },
    {
      fieldName: "color",
      fieldShowName: "表面处理",
      width: 120,
    },
    {
      fieldName: "formulaName",
      fieldShowName: "图号",
      width: 120,
    },
    {
      fieldName: "length",
      fieldShowName: "长度",
      width: 120,
    },
    {
      fieldName: "totalQuantities",
      fieldShowName: "组数",
      width: 120,
    },
    {
      fieldName: "completionQuantity",
      fieldShowName: "已完成组数",
      width: 120,
    },
    {
      fieldName: "totalPieces",
      fieldShowName: "柱/档数",
      width: 120,
    },
    {
      fieldName: "completionPieces",
      fieldShowName: "已完成柱/档数",
      width: 120,
    },
  ];

  const getData = (homeParams:any) => {
    let arr: any = [];
    let onSelectRows = CompletionListRef.current.getCheckedItem();
    onSelectRows.forEach(
    // selectedRows.forEach(
      (item: {
        quantity: string;
        pieces: string;
        length: string;
        totalQuantities: string;
        totalPieces: string;
        isMultiple: string;
        psiId: string;
        psiName: string;
        specs: string;
        userId: string;
        uuid: any;
        skuId: any;
        blankingId: any;
        skuName: any;
        formulaName: any;
        orderNo: any;
        practicalQuantity: any;
        practicalLength: any;
        bomTotalQuantity: any;
        completeTime: any;
        ref: { workshopId: any };
        orderDetailId: any;
        orderTime: any;
        workflowId: any;
        staffId: any;
        isReturning: any;
        isOther: any;
        remarkId: any;
        procedureId: any;
        orderCalType: any;
        joinedStaffsId: any;
        fillingId: any;
        submitId: any;
      }) => {
        arr.push({
          uuid: item.uuid,
          skuId: item.skuId,
          blankingId: item.blankingId,
          skuName: item.skuName,
          formulaName: item.formulaName,
          length: item.length || "",
          psiId: item.psiId || "",
          psiName: item.psiName || "",
          specs: item.specs || "",
          isMultiple: item.isMultiple,
          isReturning: homeParams?.isReturning,
          orderNo: item.orderNo,
          workshopId: item.ref.workshopId,
          orderDetailId: item.orderDetailId,
          orderTime:
            window.location.href
              .substring(window.location.href.indexOf("?") + 1)
              .split("&")[8]
              .split("=")[1] == "true"
              ? moment(item.completeTime, "YYYY-MM-DD HH:mm:ss").format(
                  "YYYY-MM-DD"
                )
              : item.orderTime,
          workflowId: item.workflowId,
          quantity: item.quantity || "0",
          piecesQuantity: item.pieces || "0",
          totalQuantities: item.totalQuantities || "0",
          totalPieces: item.totalPieces || "0",
          practicalQuantity: item.practicalQuantity || "0",
          practicalLength: item.practicalLength || "0",
          bomTotalQuantity: item.bomTotalQuantity || "0",
          fillingId: item.fillingId,
          submitId: item.submitId,
        });
      }
    );
    let completionListJson = {
      isReturning: homeParams?.isReturning,
      isOther: homeParams?.isOther,
      workshopId: homeParams?.workshopId,
      procedureId: homeParams?.procedureId,
      remarkId: homeParams?.remarkId,
      staffId: homeParams?.staffId,
      orderCalType: homeParams?.orderCalType,
      useGroup: homeParams?.useGroup,
      groupId: homeParams?.groupId,
      joinedStaffsId: homeParams?.joinedStaffsId,
      completionList: arr,
      fillingId: homeParams?.fillingId,
      submitId: homeParams?.submitId,
    };
    return completionListJson;
  };

  const onSave = async (status: string) => {
    let onSelectRows = CompletionListRef.current.getCheckedItem();
    setSelectedRows(onSelectRows);
    let obj = CompletionListRef.current.getcompletionHome();
    let emptyFlag = false;
    let errorFlag = false;
    let overFlag = false;
    let overCuttingFlag = false;
    onSelectRows.forEach((item: any) => {
      if (
        (item.quantity === undefined || item.quantity === "") &&
        (item.pieces === undefined || item.pieces === "")
      ) {
        emptyFlag = true;
      }
      if (item.quantity && item.pieces) {
        errorFlag = true;
      }
      if (homeParams.isReturning === "2") {
        const alreadyQuantity =
          parseInt(item.completionQuantity || "0") +
          parseInt(item.quantity || "0");
        const alreadyPieces =
          parseInt(item.completionPieces || "0") + parseInt(item.pieces || "0");
        if (
          alreadyQuantity > parseInt(item.totalQuantities) ||
          alreadyPieces > parseInt(item.totalPieces)
        ) {
          overFlag = true;
        }
      }
      if (
        window.location.href
          .substring(window.location.href.indexOf("?") + 1)
          .split("&")[8]
          .split("=")[1] == "true"
      ) {
        const alreadyQuantity =
          parseInt(item.quantity || "0") + parseInt(item.outQuantity || "0");
        if (alreadyQuantity > parseInt(item.practicalQuantity)) {
          overCuttingFlag = true;
        }
      }
    });
    if (emptyFlag) {
      Toast.fail("您选中的订单未填写本次组数或本次柱/档数！");
      return;
    }
    if (errorFlag) {
      Toast.fail("本次组数 和 本次柱/档数只能填写一项，请检查！");
      return;
    }
    if (overFlag) {
      Toast.fail(
        "您选中的订单本次组数超过总组数或者本次柱/档数超过总柱/档数！"
      );
      return;
    }
    if (overCuttingFlag) {
      Toast.fail("您选中的订单本次下料数量超过可填写数量！");
      return;
    }
    const params = {
      isReturning: obj?.isReturning,
      isOther: obj?.isOther,
      workshopId: obj?.workshopId,
      procedureId: obj?.procedureId,
      remarkId: obj?.remarkId,
      staffId: obj?.staffId,
      orderCalType: obj?.orderCalType,
      useGroup: obj?.useGroup,
      groupId: obj?.groupId,
      joinedStaffsId: obj?.joinedStaffsId,
      fillingId: obj?.fillingId,
      workDate: obj?.workDate,
      submit: obj?.submitId,
    }
    setHomeParams(params);
    if (status === "save") {
      const data = getData(params);
      const resp = await instance.post<Result<string>>(
        `/erp/sku/workshop/insertCompletionList`,
        {
          completionListJson: JSON.stringify(data),
          status: status,
        }
      );
      if (resp.data.Status === "1") {
        Toast.success(`操作成功！`);
      }
    } else {
      setSubmitForm((prev) => ({
        ...prev,
        visible: true,
        procedureId: obj?.procedureId,
        staffId: obj?.staffId,
        orderCalType: obj?.orderCalType,
        joinedStaffsId: obj?.joinedStaffsId,
        selectedCount: onSelectRows.length,
        status: status,
      }));
    }
  };

  return (
    <>
      <div
        style={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div style={{ flex: 1, overflowY: "auto" }}>
          <WorkDataList
            step={step}
            url={
              "/erp/sku/workshop/getDistributedList?procedureId=" +
              window.location.href
                .substring(window.location.href.indexOf("?") + 1)
                .split("&")[0]
                .split("=")[1] +
              "&staffId=" +
              (submitForm.orderCalType === "1"
                ? submitForm.staffId
                : submitForm.joinedStaffsId) +
              "&workshopId=" +
              window.location.href
                .substring(window.location.href.indexOf("?") + 1)
                .split("&")[6]
                .split("=")[1]
            }
            ref={CompletionListRef}
            key={
              "/erp/sku/workshop/getDistributedList?procedureId=" +
              window.location.href
                .substring(window.location.href.indexOf("?") + 1)
                .split("&")[0]
                .split("=")[1] +
              "&staffId=" +
              (submitForm.orderCalType === "1"
                ? submitForm.staffId
                : submitForm.joinedStaffsId) +
              "&workshopId=" +
              window.location.href
                .substring(window.location.href.indexOf("?") + 1)
                .split("&")[6]
                .split("=")[1]
            }
            returning={homeParams?.isReturning === "1"}
            isCutting={
              window.location.href
                .substring(window.location.href.indexOf("?") + 1)
                .split("&")[8]
                .split("=")[1]
            }
            rowSelectionType="checkbox"
            // sorter={{ field: "completeTime desc,orderNo asc,orderDetailId asc", order: "" }}
            descriptions={
              window.location.href
                .substring(window.location.href.indexOf("?") + 1)
                .split("&")[8]
                .split("=")[1] == "true"
                ? descriptionCutting
                : descriptionNoCutting
            }
            homeParams={homeParams}
          />
        </div>
        {step === 1 ? (
          <Button
            style={{ width: "100%", zIndex: 99 }}
            type="primary"
            onClick={() => {
              let onSelectRows = CompletionListRef.current.getCheckedItem();
              if (onSelectRows.length === 0) {
                Toast.fail("请您至少选择一条数据再确定！");
                return;
              }
              setStep(2);
            }}
          >
            填报清单
          </Button>
        ) : (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-around",
              background: "#fff",
            }}
          >
            <Button
              style={{ width: "30%", zIndex: 99 }}
              onClick={() => onSave("save")}
            >
              保存
            </Button>
            <Button
              type="primary"
              style={{ width: "30%", zIndex: 99 }}
              onClick={() => onSave("submit")}
            >
              提交
            </Button>
            <Button
              style={{ width: "30%", zIndex: 99 }}
              type="primary"
              onClick={() => {
                setStep(1);
              }}
            >
              返回
            </Button>
          </div>
        )}
      </div>
      <Modal
        title={"工量填报"}
        visible={submitForm.visible}
        onClose={() => {
          setSubmitForm((prev) => ({
            ...prev,
            visible: false,
          }));
        }}
        transparent
        maskClosable={false}
        closable={true}
        footer={[
          {
            text: "取消",
            onPress: () => {
              setSubmitForm((prev) => ({
                ...prev,
                visible: false,
              }));
            },
          },
          {
            text: "提交",
            onPress: async () => {
              setSubmitForm((prevState) => ({
                ...prevState,
                visible: false,
              }));
              setDialogForm({
                visible: true,
              });
            },
          },
        ]}
      >
        <List>
          <DictionarySelect
            title={"工序"}
            multiple={false}
            dictionary={"erp_procedure"}
            value={submitForm.procedureId}
            disabled={true}
          />
        </List>
        <List>
          <DictionarySelect
            title={"员工"}
            multiple={false}
            disabled={true}
            dictionary={"base_staff"}
            value={submitForm.staffId}
          />
        </List>
        <List>
          <DictionarySelect
            title={"类型"}
            multiple={false}
            disabled={true}
            dictionary={"dict_order_production_cal_type"}
            value={submitForm.orderCalType}
          />
        </List>
        <List>
          <DictionarySelect
            title={"参与员工"}
            multiple={true}
            disabled={true}
            dictionary={"base_staff"}
            value={submitForm.joinedStaffsId}
          />
        </List>
        <List>
          <InputItem type={"text"} value={submitForm.selectedCount} disabled>
            已选产品
          </InputItem>
        </List>
      </Modal>
      <Modal
        title={"确认"}
        visible={dialogForm.visible}
        onClose={() => {
          setDialogForm({
            visible: false,
          });
        }}
        transparent
        maskClosable={false}
        closable={true}
        footer={[
          {
            text: "取消",
            onPress: () => {
              setDialogForm({
                visible: false,
              });
            },
          },
          {
            text: "确定",
            onPress: async () => {
              //let onSelectRows = CompletionListRef.current.getCheckedItem();
              let arr: any = [];
              selectedRows.forEach(
                (item: {
                  quantity: string;
                  pieces: string;
                  length: string;
                  totalQuantities: string;
                  totalPieces: string;
                  isMultiple: string;
                  psiId: string;
                  psiName: string;
                  specs: string;
                  userId: string;
                  uuid: any;
                  skuId: any;
                  blankingId: any;
                  skuName: any;
                  formulaName: any;
                  orderNo: any;
                  practicalQuantity: any;
                  practicalLength: any;
                  bomTotalQuantity: any;
                  completeTime: any;
                  ref: { workshopId: any };
                  orderDetailId: any;
                  orderTime: any;
                  workflowId: any;
                  staffId: any;
                  isReturning: any;
                  isOther: any;
                  remarkId: any;
                  procedureId: any;
                  orderCalType: any;
                  joinedStaffsId: any;
                  fillingId: any;
                  submitId: any;
                }) => {
                  arr.push({
                    uuid: item.uuid,
                    skuId: item.skuId,
                    blankingId: item.blankingId,
                    skuName: item.skuName,
                    formulaName: item.formulaName,
                    length: item.length || "",
                    psiId: item.psiId || "",
                    psiName: item.psiName || "",
                    specs: item.specs || "",
                    isMultiple: item.isMultiple,
                    isReturning: homeParams?.isReturning,
                    orderNo: item.orderNo,
                    workshopId: item.ref.workshopId,
                    orderDetailId: item.orderDetailId,
                    orderTime:
                      window.location.href
                        .substring(window.location.href.indexOf("?") + 1)
                        .split("&")[8]
                        .split("=")[1] == "true"
                        ? moment(
                            item.completeTime,
                            "YYYY-MM-DD HH:mm:ss"
                          ).format("YYYY-MM-DD")
                        : item.orderTime,
                    workflowId: item.workflowId,
                    quantity: item.quantity || "0",
                    piecesQuantity: item.pieces || "0",
                    totalQuantities: item.totalQuantities || "0",
                    totalPieces: item.totalPieces || "0",
                    practicalQuantity: item.practicalQuantity || "0",
                    practicalLength: item.practicalLength || "0",
                    bomTotalQuantity: item.bomTotalQuantity || "0",
                    fillingId: item.fillingId,
                    submitId: item.submitId,
                  });
                }
              );
              let completionListJson = {
                isReturning: homeParams?.isReturning,
                isOther: homeParams?.isOther,
                workshopId: homeParams?.workshopId,
                procedureId: homeParams?.procedureId,
                remarkId: homeParams?.remarkId,
                staffId: homeParams?.staffId,
                orderCalType: homeParams?.orderCalType,
                useGroup: homeParams?.useGroup,
                groupId: homeParams?.groupId,
                joinedStaffsId: homeParams?.joinedStaffsId,
                completionList: arr,
                fillingId: homeParams?.fillingId,
                submitId: homeParams?.submitId,
                workDate: homeParams?.workDate,
              };
              const resp = await instance.post<Result<string>>(
                `/erp/sku/workshop/insertCompletionList`,
                {
                  completionListJson: JSON.stringify(completionListJson),
                  status: submitForm.status,
                }
              );
              if (resp.data.Status === "1") {
                Toast.success(`操作成功！`);
                debugger;
                if(homeParams?.isReturning === "1"){
                  // 返修填报审核
                  var id = resp.data.Data;
                  instance
                    .post("/wf/form/vsheet/submit", {
                      id: id,
                      name: "返修计件工量填报",
                    })
                    .then((data) => {
                      if (data.data.Status === "1") {
                        history.go(-1);
                      } else {
                        Toast.fail(
                          "返修计件工量填报自动提交审核失败！失败原因：" +
                            data.data.Data
                        );
                      }
                    });
                }else{
                  if (
                    window.location.href
                      .substring(window.location.href.indexOf("?") + 1)
                      .split("&")[8]
                      .split("=")[1] == "true"
                  ) {
                    debugger;
                    console.log("11111111111111111111111");
                    console.log(homeParams?.isReturning);                    
                    // 生成领料单
                    var ids = resp.data.Data.split(",");
                    for (let i = 0; i < ids.length; i++) {
                      instance
                        .post("/wf/form/vsheet/submit", {
                          id: ids[i],
                          name: "手机领料单",
                        })
                        .then((data) => {
                          if (data.data.Status === "1") {
                            history.go(-1);
                          } else {
                            Toast.fail(
                              "手机领料单自动提交审核失败！失败原因：" +
                                data.data.Data
                            );
                          }
                        });
                    }
                  } else {
                    history.go(-1);
                  }
                }
              } else {
                Toast.fail(resp.data.Data);
              }
              setDialogForm({
                visible: false,
              });
              setSubmitForm({
                visible: false,
              });
            },
          },
        ]}
      >
        <p style={{ fontSize: "20px" }}>确认提交本次完成数量吗？</p>
      </Modal>
    </>
  );
}
function useCallback(arg0: () => Promise<void>, arg1: never[]) {
  throw new Error("Function not implemented.");
}
